/* eslint-disable no-console */
import { getReport } from '@app/api/reports';
import { useUserSession } from '@app/contexts/providers/UserSessionProvider';
import { snakeToCamelCase } from '@app/utils/snakeCamelTransform';
import { Query, useQueries } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Report } from './types';

export const GET_REPORT_QUERY = 'GET_REPORT_QUERY';

const fetchReport = async (companyId: string, reportId: string): Promise<Report> => {
  const response = await getReport({
    companyId,
    reportId,
  });

  return { id: reportId, ...snakeToCamelCase(response) };
};

export const useGetReportQueries = (reportIds: string[]) => {
  const { company } = useUserSession();

  return useQueries({
    queries: reportIds.map((reportId) => ({
      queryKey: [GET_REPORT_QUERY, reportId],
      queryFn: () => fetchReport(company.id, reportId),
      refetchInterval: (report: unknown, query: Query) => {
        if (!report) {
          const error = query?.state.error as AxiosError | undefined;
          if (!error || error.status === 404) {
            // Sometimes, the error is 404, but the report is still being processed.
            // In this case, we want to refetch the report.
            return 1000;
          }
          return false;
        }

        const { state } = report as Report;

        if (state !== 'complete' && state !== 'failed') {
          return 3000;
        }

        return false;
      },
    })),
  });
};
